import { render, staticRenderFns } from "./GetAccess.vue?vue&type=template&id=7eb0d50b&scoped=true&"
import script from "./GetAccess.vue?vue&type=script&lang=js&"
export * from "./GetAccess.vue?vue&type=script&lang=js&"
import style0 from "./GetAccess.vue?vue&type=style&index=0&id=7eb0d50b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb0d50b",
  null
  
)

export default component.exports